import PageCertificateElement from "../../formability/certificateBuilder/models/pageCertificateElement";
import Certificate from "../../formability/certificateBuilder/models/certificate";

export default {
  methods: {
    // Note: Requires orderedItems() to be a computed property
    resetSortOrder() {
      const items = this.orderedItems;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.sort_order !== i) {
          // Not in expected order
          item.sort_order = i;
        }
      }
    },
    moveUp(item) {
      if (item.sort_order <= 0) {
        return;
      }
      const desiredSortOrder = item.sort_order - 1;
      let index = 0;
      for (const other of this.orderedItems) {
        if (other.sort_order !== index) {
          // Not in expected order
          other.sort_order = index;
        }
        if (other.sort_order  === desiredSortOrder) {
          other.sort_order++;
          break;
        }
        index++;
      }
      item.sort_order--;
    },
    moveDown(item) {
      const orderedItems = this.orderedItems;
      if (item.sort_order >= orderedItems.length - 1) {
        return;
      }
      const desiredSortOrder = item.sort_order + 1;
      let index = 0;
      for (const other of orderedItems) {
        if (other.sort_order !== index) {
          // Not in expected order
          other.sort_order = index;
        }
        if (other.sort_order === desiredSortOrder) {
          other.sort_order--;
          break;
        }
        index++;
      }
      item.sort_order++;
    },
    canMoveUp(item): boolean {
      return item.sort_order > 0;
    },
    canMoveDown(item): boolean {
      return item.sort_order < this.orderedItems.length - 1;
    },
    moveToBottom(item) {
      const orderedItems = this.orderedItems;
      const currentSortOrder = item.sort_order;
      const desiredSortOrder = orderedItems.length - 1;
      for (const other of orderedItems) {
        if (other.sort_order > currentSortOrder) {
          other.sort_order--;
        }
      }
      item.sort_order = desiredSortOrder;
    },
    moveToTop(item) {
      const currentSortOrder = item.sort_order;
      const desiredSortOrder = 0;
      for (const other of this.orderedItems) {
        if (other.sort_order < currentSortOrder) {
          other.sort_order++;
        } else {
          break;
        }
      }
      item.sort_order = desiredSortOrder;
    },
    // methods exclusively for moving certificate pages and their elements
    movePageUp(page: PageCertificateElement, certificate: Certificate): void {
      const previousPage = certificate.pageElements.find(p => p.sort_order === page.sort_order - 1);
      if (previousPage) PageCertificateElement.shiftPageElements(previousPage, 'down');
      PageCertificateElement.shiftPageElements(page, 'up');
      this.moveUp(page);
    },
    movePageDown(page: PageCertificateElement, certificate: Certificate): void {
      const nextPage = certificate.pageElements.find(p => p.sort_order === page.sort_order + 1);
      if (nextPage) PageCertificateElement.shiftPageElements(nextPage, 'up');
      PageCertificateElement.shiftPageElements(page, 'down');
      this.moveDown(page);
    }
  }
};